import { Provider } from 'react-redux'
import { createStore } from 'redux'
import Routes from 'routes'
import reducers from 'store'

const store = createStore(reducers)

function App() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  )
}

export default App
